module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/MM-19da38255c9b558d905902220efb95b2.png";